export const isValidState = (errors) => {
    if (!errors || !errors.length)
        return true;
    return false;
};
